import { Link } from "react-router-dom";
import PRIVACY from "../legal/privacy";
import TERMS from "../legal/terms";

function inline(text, kb) {
  const parts = String(text).split(/\*\*(.+?)\*\*/g);
  return parts.map((p, i) =>
    i % 2 === 1 ? <strong key={`${kb}-${i}`} className="font-semibold text-ink">{p}</strong> : p
  );
}

function parseBlocks(md) {
  const blocks = [];
  let list = null;
  md.split("\n").forEach((line) => {
    const t = line.trim();
    if (/^[-*] /.test(t)) {
      if (!list) { list = { type: "ul", items: [] }; blocks.push(list); }
      list.items.push(t.replace(/^[-*] /, ""));
      return;
    }
    list = null;
    if (/^### /.test(t)) blocks.push({ type: "h3", text: t.slice(4) });
    else if (/^## /.test(t)) blocks.push({ type: "h2", text: t.slice(3) });
    else if (/^# /.test(t)) blocks.push({ type: "h1", text: t.slice(2) });
    else if (/^-{3,}$/.test(t)) blocks.push({ type: "hr" });
    else if (t) blocks.push({ type: "p", text: t });
  });
  return blocks;
}

export default function Legal({ doc }) {
  const isPrivacy = doc === "privacy";
  const blocks = parseBlocks(isPrivacy ? PRIVACY : TERMS);
  return (
    <div className="min-h-screen bg-paper">
      <header className="border-b border-hairline bg-surface/80 backdrop-blur-xl sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-6 h-14 flex items-center justify-between">
          <Link to="/" className="font-display font-medium text-xl tracking-tight text-ink" data-testid="legal-brand-link">wandr</Link>
          <nav className="flex gap-4 text-xs font-semibold">
            <Link to="/privacy" className={isPrivacy ? "text-ember" : "text-sand-500 hover:text-ink"} data-testid="legal-nav-privacy">Privacy</Link>
            <Link to="/terms" className={!isPrivacy ? "text-ember" : "text-sand-500 hover:text-ink"} data-testid="legal-nav-terms">Terms</Link>
          </nav>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-10 md:py-14 pb-24" data-testid={`legal-${doc}`}>
        {blocks.map((b, i) => {
          if (b.type === "h1") return <h1 key={i} className="font-display font-medium text-3xl sm:text-4xl tracking-tight mb-2">{inline(b.text, i)}</h1>;
          if (b.type === "h2") return <h2 key={i} className="font-display font-medium text-lg text-ink mt-8 mb-2">{inline(b.text, i)}</h2>;
          if (b.type === "h3") return <h3 key={i} className="text-sm font-semibold text-ink mt-5 mb-1.5">{inline(b.text, i)}</h3>;
          if (b.type === "hr") return <div key={i} className="border-t border-sand-200 my-6" />;
          if (b.items) return (
            <ul key={i} className="list-disc pl-5 space-y-1.5 text-sm leading-relaxed text-sand-700 mb-3">
              {b.items.map((it, j) => <li key={j}>{inline(it, `${i}-${j}`)}</li>)}
            </ul>
          );
          return <p key={i} className="text-sm leading-relaxed text-sand-700 mb-3">{inline(b.text, i)}</p>;
        })}
        <div className="mt-12 pt-6 border-t border-hairline text-xs text-sand-400">
          Wandr · <Link to="/privacy" className="hover:text-ember">Privacy Policy</Link> · <Link to="/terms" className="hover:text-ember">Terms of Service</Link>
        </div>
      </main>
    </div>
  );
}
